import type React from "react";
import { ReactComponent as Svg } from "./assets/pointer-right.svg";
import * as styles from "./Icon.module.scss";

type PointerRightProps = React.SVGProps<SVGSVGElement>;

export const PointerRight = ({ className, ...props }: PointerRightProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
